import type { Transaction } from '@shared/transactions-types';
import { wrapUrlWithReturnUrl } from '@luna/router';

import { getRouteToTransactionsHistory } from './getRouteToTransactionsHistory';

export function getRouteToTransactionDetails(transaction: Transaction): string | undefined {
    const routeToHistory = getRouteToTransactionsHistory(transaction);

    if (!routeToHistory) {
        return undefined;
    }

    const routeToDetails = `${routeToHistory}/pages/${transaction.id}`;
    return wrapUrlWithReturnUrl(routeToDetails);
}
